import React, { Suspense } from "react";
import { useParams } from "react-router-dom";

import ComponentLoader from "@performyard/py-components/src/components/atoms/ComponentLoader";

import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

import LegacyEditReviewTemplate from "../EditReviewTemplate";

// Legacy stays a static import while the flag is off for everyone, so the common path does not
// pay for an extra chunk. Flip these once the refresh is the default.
const RefreshedReviewTemplateDetailPage = React.lazy(() => import("./ReviewTemplateDetailPage"));

const ReviewTemplateDetail = () => {
	const { templateID } = useParams<{ templateID?: string }>();
	const { value: isRefreshEnabled, query } = useFeatureFlagQuery<boolean>(
		"ff-temp-is-review-template-createedit-refresh-enabled",
		false
	);

	if (query.isLoading) {
		return <ComponentLoader />;
	}

	if (isRefreshEnabled) {
		return (
			<Suspense fallback={<ComponentLoader />}>
				<RefreshedReviewTemplateDetailPage templateId={templateID || null} />
			</Suspense>
		);
	}

	return <LegacyEditReviewTemplate />;
};

export default ReviewTemplateDetail;
